import { defineStore } from "pinia";

export const useCatalogPublicationImprintsStore = defineStore("CatalogPublicationImprintsStore", {
  state: () => ({
    data: null,
    loading: false,
  }),
  actions: {
    async fetchCatalogPublicationImprints(query) {
      this.loading = true;
      try {
        const response = await this.$axios.get(`/api/v1/catalog/imprints?q[name_cont]=${query}`);
        this.data = response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      this.loading = false;
    },
    async fetchImprint(id) {
      try {
        const response = await this.$axios.get(`api/v1/catalog/imprint/${id}`);
        return response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  }
});
